import React from 'react'
import { leagueGamesStore } from 'state/league/leageGames'
import { manageTeamStore } from 'state/league/manageTeam'
import { leagueUpdatesStore } from 'state/league/leagueUpdates'
import { leaguePracticeStore } from 'state/league/leaguePractice'
import SelectGame from './Modals/SelectGame'
import EnterScore from './Modals/EnterScore'
import SelectGameForLog from './Modals/SelectGameForLog'
import EnterLog from './Modals/EnterLog'
import LiveLog from './Modals/LiveLog'
import ManagePlayersModal from './Modals/ManagePlayersModal'
import ManageteamModal from './Modals/ManageteamModal'
import AddTeamModal from './Modals/AddTeamModal'
import AddDiscountModal from './Modals/AddDiscountModal'
import CreateLeagueTeamModal from './Modals/CreateLeagueTeamModal'
import AddGameModal from './Tabs/Modals/Schedule/AddGameModal'
import AddPracticeModal from './Tabs/Modals/Schedule/AddPracticeModal'
import EditTimeModal from './Tabs/Modals/Schedule/EditTimeModal'
import EditFieldModal from './Tabs/Modals/Schedule/EditFieldModal'
import AddUpdateModal from './Tabs/Modals/Updates/AddUpdateModal'

/**
 * Mounts the League "Manage league" modals so ALL the dropdown actions work outside
 * the League Details screen (e.g. from the Spaces listing). Driven by the singleton
 * league stores — the caller (ManageButtonLeague) loads the target league into
 * leagueEventStore before opening a modal, so each modal has its `leagueData` context.
 *
 * IMPORTANT: this must mount the SAME modal set the Details screen mounts, which is
 * split across TWO files — InfoHeader.tsx (games / schedule / players / updates) and
 * index.tsx (team sub-modals). If any modal is missing here, its action sets a store
 * flag with no mounted modal on the listing → nothing opens, and it only opens later
 * when Details mounts it ("leaks" into Details). Keep this in sync with both files.
 */
const LeagueManageModals: React.FC = () => {
  const {
    addGameModal,
    selectGameModal,
    addScoreModal,
    editTimeModal,
    editFieldModal,
    selectGameForLogModal,
    enterLogModal,
    liveLogModal,
  } = leagueGamesStore(store => ({
    addGameModal: store.addGameModal,
    selectGameModal: store.selectGameModal,
    addScoreModal: store.addScoreModal,
    editTimeModal: store.editTimeModal,
    editFieldModal: store.editFieldModal,
    selectGameForLogModal: store.selectGameForLogModal,
    enterLogModal: store.enterLogModal,
    liveLogModal: store.liveLogModal,
  }))
  const { addPracticeModal } = leaguePracticeStore(store => ({
    addPracticeModal: store.addPracticeModal,
  }))
  const {
    manageTeamModal,
    managePlayersModal,
    addTeamModal,
    addDiscountModal,
    createLeagueTeamModal,
  } = manageTeamStore(state => ({
    manageTeamModal: state.manageTeamModal,
    managePlayersModal: state.managePlayersModal,
    addTeamModal: state.addTeamModal,
    addDiscountModal: state.addDiscountModal,
    createLeagueTeamModal: state.createLeagueTeamModal,
  }))
  const { addUpdateModal, editUpdateModal } = leagueUpdatesStore(store => ({
    addUpdateModal: store.addUpdateModal,
    editUpdateModal: store.editUpdateModal,
  }))

  return (
    <>
      {/* Games / scores / logs */}
      {addGameModal && <AddGameModal />}
      {addPracticeModal && <AddPracticeModal />}
      {selectGameModal && <SelectGame />}
      {addScoreModal && <EnterScore />}
      {selectGameForLogModal && <SelectGameForLog />}
      {enterLogModal && <EnterLog />}
      {liveLogModal && <LiveLog />}
      {editTimeModal && <EditTimeModal />}
      {editFieldModal && <EditFieldModal />}
      {/* Teams & players */}
      {manageTeamModal && <ManageteamModal />}
      {managePlayersModal && <ManagePlayersModal />}
      {addTeamModal && <AddTeamModal />}
      {addDiscountModal && <AddDiscountModal />}
      {createLeagueTeamModal && <CreateLeagueTeamModal />}
      {/* Updates */}
      {(addUpdateModal || editUpdateModal) && <AddUpdateModal />}
    </>
  )
}

export default LeagueManageModals
